import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import styled from "styled-components";
import useStore from "@state/store";
import { useSocketIO } from "@providers/sockets/SocketIOProvider";
import { useJoinRoom } from "../hooks/useJoinRoom";
import roomToNavMap from "@data/roomToNav.map.json";
import GalleryScreen from "@components/gallery/GalleryScreen";
import FavoritesScreen from "@components/favorties/FavoritesScreen";
import { Logo } from "@components/logo";
import OverviewScreen from "@components/overview/Overview";
import SocketStatus from "@components/socket-status/SocketStatus";

function ScreenLayout() {
  const { socket, onGotNavigation, onGotReload, onSyncMultipleState } =
    useSocketIO();
  const { roomConnectAttempt } = useJoinRoom();
  const navigate = useNavigate();
  const { setLocalState } = useStore((s) => ({
    setLocalState: s.setLocalState,
  }));
  const { overviewVisible, galleryVisible, favoritesVisible, isTablet } =
    useStore((s) => ({
      overviewVisible: s.overviewVisible,
      galleryVisible: s.galleryVisible,
      favoritesVisible: s.favoritesVisible,
      isTablet: s.isTablet,
    }));

  useEffect(() => {
    onGotReload(() => {
      navigate("/");
      setLocalState({ path: "/" });
      window.location.reload();
    });

    onSyncMultipleState((payload: any) => {
      setLocalState(payload);
    });

    socket.io.on("reconnect", (e) => {
      console.log("Reconnected", e);
      roomConnectAttempt();
    });
  }, []);

  const roomFromLabel =
    (window as any)?.__TAURI_METADATA__?.__currentWindow?.label?.split(
      "luna-720",
    )[1] ?? "room2"; //ROOMNAME

  useEffect(() => {
    const path = roomToNavMap[roomFromLabel || "room2"].nav; //ROOMNAME
    const navigateTo = `/${path}`;
    navigate(navigateTo);
    setLocalState({ path: navigateTo });

    onGotNavigation((payload: any) => {
      navigate(payload.path);
      setLocalState({ path: payload.path });
    });
  }, []);

  useEffect(() => {
    if (!isTablet) {
      roomConnectAttempt(null, roomFromLabel || "room2"); //ROOMNAME
    }
  }, [isTablet]);

  return (
    <ScreenLayoutWrapper>
      {socket?.connected
        ? null
        : (
          <SocketStatus
            strokeWidth={20}
            color="#dd0000"
            bgColor="transparent"
          />
        )}
      <div className="logo-text-wrap">
        <Logo location={location.pathname} />
      </div>
      <GalleryScreen isVisible={galleryVisible} />
      <OverviewScreen isVisible={overviewVisible} />
      <FavoritesScreen isVisible={favoritesVisible} />
      <Outlet />
    </ScreenLayoutWrapper>
  );
}

export default ScreenLayout;

const ScreenLayoutWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #1d1d1d;

  .logo-text-wrap {
    position: absolute;
    top: 2em;
    right: 2em;
    color: white;
    z-index: 150;
  }

  .text {
    position: absolute;
    top: 5%;
    left: 50%;
    transform: translate(-50%, -50%);

    font-size: 5em;
    font-weight: 700;
    color: #fff;
  }
`;
